import { Figure } from "/react4xp/parts/figure/figure";

export default (props) => <Figure {...props} />